export let OriginApp = /*#__PURE__*/function (OriginApp) {
  OriginApp["ADI"] = "ADI";
  OriginApp["Editor"] = "Editor";
  OriginApp["StudioEditor"] = "StudioEditor";
  OriginApp["BusinessManager"] = "BusinessManager";
  OriginApp["IntroFunnel"] = "IntroFunnel";
  OriginApp["TemplatesGallery"] = "TemplatesGallery";
  OriginApp["TemplatesViewer"] = "TemplatesViewer";
  OriginApp["PackagePicker"] = "PackagePicker";
  OriginApp["AcceptPayments"] = "AcceptPayments";
  OriginApp["WixPayments"] = "WixPayments";
  OriginApp["Hopp"] = "Hopp";
  OriginApp["AccountManager"] = "AccountManager";
  OriginApp["SitesList"] = "SitesList";
  OriginApp["Landing"] = "Landing";
  OriginApp["Contact"] = "Contact";
  OriginApp["test"] = "test";
  OriginApp["USP"] = "USP";
  return OriginApp;
}({});
//# sourceMappingURL=origin.js.map